import angular from 'angular';
import uiRouter from 'angular-ui-router';
import 'oclazyload';


let lazyState = {
    name: 'home.**',
    url: '/home'
};

let homeModule = angular.module('home', [
    uiRouter,
    "oc.lazyLoad"
])

    .config(($stateProvider, $compileProvider) => {
        "ngInject";

        lazyState.lazyLoad = (transition) => {

            let injector = transition.injector();

            let $q = injector.get('$q');
            let $ocLazyLoad = injector.get('$ocLazyLoad');

            let deferred = $q.defer();

            // Webpack code splitting point
            require.ensure([], function (require) {

                // In babel 6 ".default" must be manually added
                let homeComponent = require('./home.component').default;

                let modules = [];
                modules.push(require('./dashboard/dashboard').default);
                modules.push(require('./originals/originals').default);
                modules.push(require('./profile/profile').default);
                modules.push(require('./publish/publish').default);
                modules.push(require('./realname/realname').default);
                modules.push(require('./reprint/reprint').default);
                modules.push(require('./infringements/infringements').default);
                modules.push(require('./evidences/evidences').default);
                modules.push(require('./import/import').default);
                modules.push(require('./messages/messages').default);
                modules.push(require('./whitelist/whitelist').default);

                let moduleStates = [];
                let moduleNames = [];

                modules.forEach((dm) => {

                    moduleNames.push(dm.name);

                    dm.states.forEach((s) => {

                        s.name = 'app.home.' + s.name;
                        moduleStates.push(s);
                    });

                });

                $ocLazyLoad
                    .inject(moduleNames)

                    .then(() => {
                        $compileProvider.component('home', homeComponent);
                    })

                    .then(() => {

                        moduleStates.unshift({
                            name: 'app.home',
                            url: '/home',
                            component: 'home',
                            // resolve: {
                            //     appUser: (userLogin) => {
                            //         "ngInject";
                            //
                            //         return userLogin.getUserOrPromise();
                            //     }
                            // }
                        });

                        deferred.resolve({
                            states: moduleStates
                        });
                    });

            }, 'home');

            return deferred.promise;
        };
    })

    .name;

let states = [
    lazyState
];

export default {name: homeModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/home/home.js